import { useState } from "react";
import Swal from "sweetalert2";

import bgImage from "../assets/img/contact/contact.jpg";

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(event.target);
    formData.append("access_key", "055295fc-9c15-410e-8c26-5f0c43b9ebe2");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      }).then((res) => res.json());

      if (res.success) {
        Swal.fire({
          title: "Message Sent!",
          text: "Thank you for contacting us.",
          icon: "success",
          confirmButtonText: "OK",
        });
        event.target.reset();
      } else {
        Swal.fire({
          title: "Oops!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Network error. Please try again later.",
        icon: "error",
        confirmButtonText: "Close",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center pt-16 sm:pt-10">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>
      {""}
      <div className="max-w-6xl w-full bg-white/50 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/30 overflow-hidden">
        <h2 className="text-3xl font-bold text-center text-yellow-500 pt-8 pb-3">
          Contact Us
        </h2>
        <div className="flex justify-center">
          <span className="block border-b-2 border-yellow-500 w-20 rounded-full mb-5"></span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-200">
          {/* Contact Form */}
          <div className="p-8 md:p-10 flex flex-col justify-center">
            <form onSubmit={onSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Type your message here..."
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-yellow-600 text-white py-2.5 rounded-lg hover:bg-yellow-700 transition-all duration-300 disabled:opacity-50"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="p-8 md:p-10 bg-gray-50 flex flex-col justify-center space-y-6 text-gray-700">
            <div>
              <h3 className="text-lg font-semibold mb-1">📍 Address</h3>
              <p>220B Keo Chea St. (184), Phnom Penh</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-1">📞 Phone</h3>
              <p>+855 81 333 000</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-1">✉️ Email</h3>
              <p>manticcup9@gmail.com</p>
            </div>

            <div className="rounded-lg overflow-hidden border border-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3908.8594695190477!2d104.92053058273048!3d11.56193048276576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310951331a20674f%3A0x516bca240d9cbacc!2sMantic%20Cup!5e0!3m2!1sen!2skh!4v1747207482444!5m2!1sen!2skh"
                width="100%"
                height="220"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mantic Cup Map"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
